import {
  AppBar,
  Box,
  Button,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../Components/BreadCrumb';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import { useEffect, useState } from 'react';
import HeaderGrid from '../components/HeaderGrid';
import MessageIcon from '@material-ui/icons/Message';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import '../../../style/index.css';
import KenButton from '../../../global_components/KenButton';
import { useTranslation } from 'react-i18next';
import {
  getExamData,
  getStudentRiskDataData,
} from '../../../Utils/apiServices';
import KenLoader from '../../../Components/KenLoader';
import { sendMailExamData } from '../../../Utils/sendMail';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'EXAM DASHBOARD',
  },
];

const dataProgress = [
  {
    id: 1,
    program: 'GMBA',
    subject: 'Subject 1',
    type: 'Offline',
    actions: 'Room 101',
  },
  {
    id: 2,
    program: 'EMBA',
    subject: 'Subject 2',
    type: 'Onlie',
    actions: 'Room 101',
  },
  {
    id: 3,
    program: 'GMBA',
    subject: 'Subject 3',
    type: 'Offline',
    actions: 'Room 101',
  },
  {
    id: 4,
    program: 'GMBA',
    subject: 'Subject 4',
    type: 'Offline',
    actions: 'Room 101',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    // color: '#F14B2D',

    background: 'rgba(241, 75, 45, 0.2)',
    // background: '#c12002',
    // background: '#EB5757',

    borderRadius: '25px',
    // border: '1px solid #c12002',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px  5px',
    color: '#c12002',
    '&:hover': {
      color: '#c12002',
      background: 'rgba(241, 75, 45, 0.2)',

      // color: '#c12002',
      // borderBottom: '#F14B2D',
    },
  },
  normal: {
    // color: '#505F79',
    color: '#02ab4a',

    background: 'rgba(138, 245, 196,0.4)',
    // background: '#27AE60',

    // background: '#02ab4a',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(138, 245, 196,0.4)',

      color: '#02ab4a',
      // border: '1px solid #02ab4a',
    },
  },
  penddingButton: {
    // color: '#505F79',
    color: '#f17100',

    background: 'rgba(255, 196, 10,0.2)',
    // background: '#27AE60',

    // background: '#02ab4a',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(255, 196, 10,0.2)',
      color: '#f17100',
      // border: '1px solid #02ab4a',
    },
  },

  errorEvulations: {
    // color: '#F14B2D',

    background: 'rgba(241, 75, 45, 0.2)',
    // background: '#c12002',
    // background: '#EB5757',

    borderRadius: '25px',
    border: '1px solid #c12002',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px  5px',
    color: '#EB5757',
    '&:hover': {
      color: '#EB5757',
      background: 'rgba(241, 75, 45, 0.2)',

      // color: '#c12002',
      // borderBottom: '#F14B2D',
    },
  },
  grayButton: {
    // color: '#505F79',
    color: '#505F79',

    background: 'rgba(196, 196, 196,0.2)',
    // background: '#27AE60',

    // background: '#505F79',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(196, 196, 196,0.2)',

      color: '#505F79',
      // border: '1px solid #02ab4a',
    },
  },
  viewButton: {
    // color: '#505F79',
    color: '#fff',

    // background: 'rgba(196, 196, 196, 0.2)',
    background: '#00218D',

    borderRadius: 3,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    '&:hover': {
      color: '#00218D',
      borderBottom: '#fff',
    },
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectStatusOptionsUpcomomgExam = [
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Incomplete',
    value: 'incomplete',
  },
  {
    label: 'Complete',
    value: 'complete',
  },
];

const selectStatusOptionsCompletedExam = [
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Incomplete',
    value: 'incomplete',
  },
  {
    label: 'Complete',
    value: 'complete',
  },
];

const selectDueInOptions = [
  {
    label: '7 Days',
    value: '7',
  },
  {
    label: '15 Days',
    value: '15',
  },
  {
    label: '30 Days',
    value: '30',
  },
];

const ExamDashboard = () => {
  const history = useHistory();
  const classes = useStyles();
  // const [selectStatusValueUpcomomgExam, setSelectStatusValueUpcomomgExam] =
  //   useState(selectStatusOptionsUpcomomgExam[0].value);

  const [selectDueInValueUpcomomgExam, setSelectDueInValueUpcomomgExam] =
    useState(selectDueInOptions[0].value);

  const [upcomingExamData, setUpcomingExamData] = useState([]);
  const [completedExamData, setcompletedExamData] = useState([]);
  const [examProgressData, setExamProgressData] = useState([]);
  const [studentInRiskData, setStudentInRiskData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectDueDaysValue, setDueDaysValue] = useState('');

  const handleSelectDueInChangeUpcomomgExam = (e) => {
    setSelectDueInValueUpcomomgExam(e.target.value);
  };

  const UpcomomgExamActionCell = (row) => {
    const { t } = useTranslation();

    console.log('rowrowrowrowrowrow', row);
    // const history = useHistory();
    let id = row.data.id;
    const handleClickView = () => {
      history.push(
        `/app/exam/questionPaper/question-paper-view/${row.data.id}`
      );
    };

    const handleClickSeatPlan = () => {
      history.push(`/app/exam/seatingPlan/arrangement/${row.data.id}`);
    };

    const handleClickSeatInvi = () => {
      history.push(`/app/exam/invigilationProctoring/${row.data.id}`);
    };

    const classes = useStyles();
    const { question_paper, seating_plan, invigilation } = row.row.values;

    return (
      <Box style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          className={
            question_paper === 'Approved' ? classes.normal : classes.error
          }
          size="small"
          variant="primary"
          // component={Link}
          style={{ padding: '0px 15px', height: '23px' }}
          onClick={handleClickView}
        >
          Qstn Paper
        </Button>

        <Button
          className={
            seating_plan === 'Created' ? classes.normal : classes.error
          }
          size="small"
          variant="primary"
          // component={Link}
          style={{ padding: '5px 15px', height: '23px' }}
          onClick={handleClickSeatPlan}
        >
          Seat Plan
        </Button>
        <Button
          className={
            invigilation === 'Assigned' ? classes.normal : classes.error
          }
          size="small"
          variant="primary"
          onClick={handleClickSeatInvi}
          // component={Link}
          style={{ padding: '5px 15px', height: '23px' }}
        >
          Invigilation
        </Button>
      </Box>
    );
  };

  const CompletedExamActionCell = (row) => {
    const classes = useStyles();
    const { evaluation, grading } = row.row.values;

    const handleClickSeatEvu = () => {
      history.push(`/app/exam/evaluation`);
    };

    const handleClickSeatGrading = () => {
      history.push(`/app/exam/grading/details`);
    };
    return (
      <Box>
        <Button
          className={
            !evaluation.includes('Not') ? classes.penddingButton : classes.error
          }
          size="small"
          variant="primary"
          // component={Link}
          // to={`${routes.currentProgrammes}/${id}/details`}
          onClick={handleClickSeatEvu}
          style={{ padding: '5px 15px', height: '23px' }}
        >
          Evaluation
        </Button>
        <Button
          className={!grading.includes('Not') ? classes.normal : classes.error}
          size="small"
          variant="primary"
          onClick={handleClickSeatGrading}
          // component={Link}
          style={{ padding: '5px 15px', height: '23px' }}
        >
          Grading
        </Button>
      </Box>
    );
  };

  const RiskActionCell = (row) => {
    const classes = useStyles();
    const actions = row.row.values.actions;
    const handleClickSeatView = () => {
      history.push(`/app/exam/student-status`);
    };

    console.log('row.rowrow.rowrow.row', actions);
    return (
      <Box>
        <Button
          className={classes.grayButton}
          size="small"
          variant="primary"
          // component={Link}
          style={{ padding: '5px 15px', height: '23px' }}
          // onClick={handleClickSeatView}
          // href={actions}
        >
          View
        </Button>
      </Box>
    );
  };

  const ProgressActionCell = (row) => {
    const classes = useStyles();
    const { id, actions } = row.row.values;

    return (
      <Box>
        <Button
          className={classes.grayButton}
          size="small"
          component={Link}
          style={{ padding: '5px 15px', height: '23px' }}

          // to={`${routes.currentProgrammes}/${id}/details`}
        >
          View
        </Button>
      </Box>
    );
  };

  const SeatingPlanCell = (row) => {
    const classes = useStyles();
    const { seating_plan } = row.row.values;

    return (
      <Box
        className={
          seating_plan === 'Created' ? classes.greenText : classes.errorText
        }
      >
        {seating_plan}
      </Box>
    );
  };

  const QuestionPaperCell = (row) => {
    const classes = useStyles();
    const { question_paper } = row.row.values;

    return (
      <Box
        className={
          question_paper === 'Approved' ? classes.greenText : classes.errorText
        }
      >
        {question_paper}
      </Box>
    );
  };

  const InvigilationCell = (row) => {
    const classes = useStyles();
    const { invigilation } = row.row.values;

    return (
      <Box
        className={
          invigilation === 'Assigned' ? classes.greenText : classes.errorText
        }
      >
        {invigilation}
      </Box>
    );
  };

  const EvaluationCell = (row) => {
    const classes = useStyles();
    const { evaluation } = row.row.values;

    return (
      <Box
        className={
          !evaluation.includes('Not') ? classes.greenText : classes.errorText
        }
      >
        {evaluation}
      </Box>
    );
  };

  const GradingCell = (row) => {
    const classes = useStyles();
    const { grading } = row.row.values;

    return (
      <Box
        className={
          !grading.includes('Not') ? classes.greenText : classes.errorText
        }
      >
        {grading}
      </Box>
    );
  };

  const columnsUpcomomgExam = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'Program',
      accessor: 'program',
      disableGlobalFilter: true,
    },
    {
      Header: 'Course',
      accessor: 'subject',
      disableGlobalFilter: true,
    },
    {
      Header: 'Term',
      accessor: 'Term',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Type',
      accessor: 'Exam_Type',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Date',
      accessor: 'exam_date',
      disableGlobalFilter: true,
    },
    {
      Header: 'Question Paper',
      accessor: 'question_paper',
      disableGlobalFilter: true,
      Cell: QuestionPaperCell,
    },
    {
      Header: 'Seating Plan',
      accessor: 'seating_plan',
      disableGlobalFilter: true,
      Cell: SeatingPlanCell,
    },
    {
      Header: 'Invigilation',
      accessor: 'invigilation',
      disableGlobalFilter: true,
      Cell: InvigilationCell,
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: UpcomomgExamActionCell,
    },
  ];

  const columnsCompletedExam = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'Program',
      accessor: 'program',
      disableGlobalFilter: true,
    },
    {
      Header: 'Course',
      accessor: 'subject',
      disableGlobalFilter: true,
    },
    {
      Header: 'Term',
      accessor: 'Term',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Type',
      accessor: 'Exam_Type',
      disableGlobalFilter: true,
    },
    {
      Header: 'Exam Date',
      accessor: 'exam_date',
      disableGlobalFilter: true,
    },
    {
      Header: 'Evaluation',
      accessor: 'evaluation',
      disableGlobalFilter: true,
      Cell: EvaluationCell,
    },
    {
      Header: 'Grading',
      accessor: 'grading',
      disableGlobalFilter: true,
      Cell: GradingCell,
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: CompletedExamActionCell,
    },
  ];

  const columnsRisk = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'ID',
      accessor: 'IDs',
      disableGlobalFilter: true,
    },
    {
      Header: 'Name',
      accessor: 'name',
      disableGlobalFilter: true,
    },
    {
      Header: 'Reason',
      accessor: 'reason',
      disableGlobalFilter: true,
    },

    {
      Header: 'View Details',
      accessor: 'actions',
      Cell: RiskActionCell,
    },
  ];

  const columnsProgress = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'Program',
      accessor: 'program',
      disableGlobalFilter: true,
    },
    {
      Header: 'Course',
      accessor: 'subject',
      disableGlobalFilter: true,
    },
    {
      Header: 'Type',
      accessor: 'type',
      disableGlobalFilter: true,
    },
    {
      Header: 'Venue / Link',
      accessor: 'actions',
      Cell: ProgressActionCell,
    },
  ];

  // const [selectStatusValueCompletedExam, setSelectStatusValueCompletedExam] =
  //   useState(selectStatusOptionsCompletedExam[0].value);

  const [selectDueInValueCompletedExam, setSelectDueInValueCompletedExam] =
    useState(selectDueInOptions[0].value);

  // const handleSelectStatusChangeCompletedExam = (e) => {
  //   setSelectStatusValueCompletedExam(e.target.value);
  // };

  const handleSelectDueInChangeCompletedExam = (e) => {
    setSelectDueInValueCompletedExam(e.target.value);
  };

  const [viewAll, setviewAll] = useState(false);
  const [viewCompletedAll, setCompletedviewAll] = useState(false);
  const [viewPendingAll, setPendingviewAll] = useState(false);
  const [viewInprogressAll, setInprogressviewAll] = useState(false);
  const [viewStdRiskAll, setStdRiskviewAll] = useState(false);

  const onViewAllCompleted = () => {
    setCompletedviewAll(true);
  };

  const onViewAllPendding = () => {
    setPendingviewAll(true);
  };

  const onViewAllInprogress = () => {
    setInprogressviewAll(true);
  };

  const onViewAllStdRisk = () => {
    setStdRiskviewAll(true);
  };
  useEffect(() => {
    let filterData = {
      duedays: selectDueInValueCompletedExam
        ? selectDueInValueCompletedExam
        : selectDueInValueUpcomomgExam,
    };
    getExamData(filterData)
      .then((res) => {
        let datacompletedExam = res.completedExamList.map((item, index) => {
          return {
            id: index + 1,
            program: item.program ? item.program : 'N/A',
            subject: item.course ? item.course : 'N/A',
            Term: item.term ? item.term : 'N/A',
            Exam_Type: item.examType ? item.examType : 'N/A',
            exam_date: item.examDate ? item.examDate : 'N/A',
            evaluation: item.evaluation ? item.evaluation : 'Not Started',
            grading: item.grading ? item.grading : 'Not Submitted',
            datacompletedExam: item,
          };
        });

        setcompletedExamData(datacompletedExam);

        let dataExamInProgress = res.inProgressExamList.map((item, index) => {
          return {
            id: index + 1,
            program: item.program ? item.program : 'N/A',
            subject: item.course ? item.course : 'N/A',
            type: item.examType ? item.examType : 'N/A',
            actions: item.examLink ? item.examLink : 'Venue',
          };
        });
        setExamProgressData(dataExamInProgress);
        // aaa
        let dataUpcomingExam = res.pendingExamList.map((item, index) => {
          return {
            id: item,
            program: item.program ? item.program : 'N/A',
            subject: item.course ? item.course : 'N/A',
            Term: item.term ? item.term : 'N/A',
            Exam_Type: item.examType ? item.examType : 'N/A',

            exam_date: item.examDate ? item.examDate : 'N/A',
            question_paper: item.quesPaperStatus ? item.quesPaperStatus : 'N/A',
            seating_plan: item.seatPlanStatus ? item.seatPlanStatus : 'N/A',
            invigilation: item.invigStatus ? item.invigStatus : 'N/A',
            dataUpcomingExam: item,
          };
        });

        setUpcomingExamData(dataUpcomingExam);
      })
      .catch((err) => {
        console.log('err', err);
      });

    getStudentRiskDataData()
      .then((res) => {
        console.log('resresresres', res);
        let dataStudentRisk = [];
        // const newRes1 = [res[0], res[1]];

        res.map((item, index) => {
          dataStudentRisk.push({
            id: index + 1,
            IDs: item.rollNumber ? item.rollNumber : 'N/A',
            name: item.name ? item.name : 'N/A',
            reason: item.reason ? item.reason : 'N/A',
            actions: item.url ? item.url : 'N/A',
          });
        });
        setStudentInRiskData(dataStudentRisk);
      })
      .catch((err) => {
        console.log('err', err);
      });
  }, [selectDueInValueCompletedExam, viewAll]);

  const completedExamDataWithLimit = completedExamData.slice(0, 2);
  const progressExamDataWithLimit = examProgressData.slice(0, 1);
  const UpcomingExamDataWithLimit = upcomingExamData.slice(0, 2);
  const viewStdRiskAllData = studentInRiskData.slice(0, 2);

  return (
    <>
      <Box>
        <Box className={`${classes.breadCrumbWrapper} ${'breadCrumbText'}`}>
          <BreadCrumb
            className="breadCrumbText"
            array={arrayBreadCrumb}
            history={history}
          />
        </Box>
        <AppBar position="static" elevation={0} className={classes.header}>
          <Toolbar
            style={{
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h6" className={classes.title}>
              Exam Dashboard
            </Typography>
            <Grid
              item
              xs={6}
              style={{ display: 'flex', justifyContent: 'end' }}
            >
              <Button
                startIcon={<MessageIcon />}
                variant="contained"
                color="primary"
                className={classes.addButton}
                component={Link}
                to={'#'}
                style={{ marginRight: '15px' }}
              >
                Send Message
              </Button>
              <Button
                startIcon={<AnnouncementIcon />}
                variant="contained"
                color="primary"
                className={classes.addButton}
                /* component={Link}
                to={'#'} */
                onClick={() => {
                  sendMailExamData();
                }}
              >
                Annnouncements
              </Button>
            </Grid>
          </Toolbar>
        </AppBar>

        <Box className={`${classes.gridKenClass} cardlsitbox`}>
          <HeaderGrid
            title="Upcoming Exams"
            count={UpcomingExamDataWithLimit.length}
            // selectStatusOptions={selectStatusOptionsUpcomomgExam}
            // selectStatusValue={selectStatusValueUpcomomgExam}
            // handleSelectStatusChange={handleSelectStatusChangeUpcomomgExam}
            selectDueInOptions={selectDueInOptions}
            selectDueInValue={selectDueInValueUpcomomgExam}
            handleSelectDueInChange={handleSelectDueInChangeUpcomomgExam}
            columns={columnsUpcomomgExam}
            data={viewPendingAll ? UpcomingExamDataWithLimit : upcomingExamData}
            onViewAll={onViewAllPendding}
          />
        </Box>
        <Box className={`${classes.gridKenClass} cardlsitbox`}>
          <HeaderGrid
            title="Completed Exams"
            count={completedExamData.length}
            // selectStatusOptions={selectStatusOptionsCompletedExam}
            // selectStatusValue={selectStatusValueCompletedExam}
            // handleSelectStatusChange={handleSelectStatusChangeCompletedExam}
            selectDueInOptions={selectDueInOptions}
            selectDueInValue={selectDueInValueCompletedExam}
            handleSelectDueInChange={handleSelectDueInChangeCompletedExam}
            columns={columnsCompletedExam}
            data={
              viewCompletedAll ? completedExamData : completedExamDataWithLimit
            }
            onViewAll={onViewAllCompleted}
          />
        </Box>

        <Grid
          container
          spacing={2}
          rowSpacing={1}
          columnSpacing={{ xs: 3, sm: 2, md: 3 }}
        >
          <Grid item xs={6}>
            <Box className={`${classes.gridKenClass} cardlsitbox`}>
              <HeaderGrid
                title="Student at Risk"
                count={studentInRiskData.length}
                columns={columnsRisk}
                data={viewStdRiskAll ? studentInRiskData : viewStdRiskAllData}
                onViewAll={onViewAllStdRisk}
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className={`${classes.gridKenClass} cardlsitbox`}>
              <HeaderGrid
                title="Exams in Progress"
                columns={columnsProgress}
                count={examProgressData.length}
                data={
                  viewInprogressAll
                    ? examProgressData
                    : progressExamDataWithLimit
                }
                onViewAll={onViewAllInprogress}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ExamDashboard;
